import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { TextEditorService } from '@fi-shared/fi-text-editor/text-editor.service';

export enum FiReplaceLinkTypes {
    Url = 0,
    Email = 1,
}

@Directive({
    selector: '[fiReplaceWithLinks]',
    host: {
        '(keydown)': 'onKeydown($event)',
        '(keyup)': 'onContentChange($event)',
        '(paste)': 'onContentChange($event)',
        '(focusout)': 'onContentChange($event)',
        '(blur)': 'onContentChange($event)',
    },
    standalone: false,
})
export class ReplaceWithLinksDirective implements AfterViewInit {
    @Input('fiReplaceWithLinks') replaceLinkTypes: FiReplaceLinkTypes[];
    @Input() ngAttachments: Array<any> = [];

    private rteCtrlKeyDown: boolean = false;
    private rteVKeyDown: boolean = false;
    private rteCmdKeyDown = false;

    private KEY_CODE_CTRL = 17;
    private KEY_CODE_CMD = 91;
    private KEY_CODE_V = 86;
    private KEY_CODE_SPACE = 32;
    private KEY_CODE_ENTER = 13;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private textEditorService: TextEditorService,
    ) {}

    ngAfterViewInit(): void {
        this.processReplaceUrls();
    }

    onKeydown(event: KeyboardEvent) {
        if (event.keyCode == this.KEY_CODE_CTRL) {
            this.rteCtrlKeyDown = true;
        } else if (event.keyCode == this.KEY_CODE_CMD) {
            this.rteCmdKeyDown = true;
        } else if (event.keyCode == this.KEY_CODE_V) {
            this.rteVKeyDown = true;
        }
    }

    isShouldProcessEvent(event) {
        return (
            event.type === 'focusout' ||
            event.keyCode == this.KEY_CODE_SPACE ||
            event.keyCode == this.KEY_CODE_ENTER ||
            this.IsContentPastedByShortKeys()
        );
    }

    onContentChange(event) {
        if (this.isShouldProcessEvent(event)) {
            this.processReplaceUrls();
        }

        if (this.IsContentPastedByMouse(event)) {
            setTimeout(() => {
                this.processReplaceUrls();
            });
        }

        this.keyupUpdatePasteKeys(event);
    }

    processReplaceUrls() {
        if (
            this.textEditorService.replaceUrls(
                this.elementRef.nativeElement,
                this.replaceLinkTypes /*, this.ngAttachments*/,
            )
        ) {
            const contentEditableElement = this.elementRef.nativeElement.matches('div[contenteditable]')
                ? this.elementRef.nativeElement
                : this.elementRef.nativeElement.querySelector('div[contenteditable]');
            if (contentEditableElement) {
                // for updating model
                contentEditableElement.dispatchEvent(new Event('change'));
            }
        }
    }

    keyupUpdatePasteKeys(event) {
        if (event.keyCode == this.KEY_CODE_CTRL) {
            this.rteCtrlKeyDown = false;
        } else if (event.keyCode == this.KEY_CODE_CMD) {
            this.rteCmdKeyDown = false;
        } else if (event.keyCode == this.KEY_CODE_V) {
            this.rteVKeyDown = false;
        }
    }

    IsContentPastedByShortKeys() {
        return this.rteVKeyDown && (this.rteCtrlKeyDown || this.rteCmdKeyDown);
    }

    IsContentPastedByMouse(event) {
        return event.type === 'paste' && !(this.rteCmdKeyDown && this.rteVKeyDown);
    }
}
